module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-22.18a39b22.png";